import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface GerminationChamber {
  id: string;
  chamberName: string;
  chamberCode: string;
  description?: string;
  maxCapacity?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateGerminationChamberRequest {
  chamberName: string;
  chamberCode: string;
  description?: string;
  maxCapacity?: number;
}

export interface UpdateGerminationChamberRequest extends CreateGerminationChamberRequest {
  id: string;
  isActive: boolean;
}

export const germinationChambersApi = {
  getAll: async (): Promise<GerminationChamber[]> => {
    const { data } = await apiClient.get<ApiResponse<GerminationChamber[]>>(
      "/germination-chambers"
    );
    return data.data ?? [];
  },

  getById: async (id: string): Promise<GerminationChamber> => {
    const { data } = await apiClient.get<ApiResponse<GerminationChamber>>(
      `/germination-chambers/${id}`
    );
    return data.data;
  },

  create: async (request: CreateGerminationChamberRequest): Promise<GerminationChamber> => {
    const { data } = await apiClient.post<ApiResponse<GerminationChamber>>(
      "/germination-chambers",
      request
    );
    return data.data;
  },

  update: async (request: UpdateGerminationChamberRequest): Promise<GerminationChamber> => {
    const { data } = await apiClient.put<ApiResponse<GerminationChamber>>(
      `/germination-chambers/${request.id}`,
      request
    );
    return data.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/germination-chambers/${id}`);
  },
};
